"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TrackableTile = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _GradientButton = _interopRequireDefault(require("./GradientButton"));
var _TrackableComponent = require("./TrackableComponent");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BasicTile = function BasicTile(_ref) {
  var image = _ref.image,
    headerBgColor = _ref.headerBgColor,
    children = _ref.children,
    onClick = _ref.onClick,
    buttonText = _ref.buttonText,
    setComponentType = _ref.setComponentType;
  // Set default type for BasicTile
  (0, _react.useEffect)(function () {
    if (setComponentType) {
      setComponentType("tile");
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_material.Card, {
    sx: {
      borderRadius: "20px",
      boxShadow: 2,
      "&.MuiCard-root": {
        backgroundColor: "rgb(255,255,255,0.5)"
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.CardMedia, {
    sx: {
      height: 128,
      width: "100%",
      bgcolor: headerBgColor,
      display: "grid",
      placeItems: "center"
    }
  }, image), /*#__PURE__*/_react["default"].createElement(_material.CardContent, {
    sx: {
      padding: "2rem"
    }
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: "0 1rem 1rem 1rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(_GradientButton["default"], {
    variant: "outlined",
    color: "black",
    clickMethod: onClick,
    sx: {
      width: "100%",
      bgcolor: "white",
      opacity: 0.1
    }
  }, buttonText)));
};
var _default = exports["default"] = BasicTile; // Create the trackable version of BasicTile
var TrackableTile = exports.TrackableTile = (0, _TrackableComponent.withTrackableComponent)(BasicTile);